/* eslint-disable max-len */
/**
 * French translations.
 */
export default {
  ACTION: {},
  ERROR: {
    FETCH_ATTACHMENTS: 'Obtenir des pièces jointes'
  },
  HEADER: {
    DATE: 'Date',
    SENT_BY_F: 'Envoyée par',
    TITLE: 'Titre'
  },
  LABEL: {
    ATTACHMENTS: 'Pièces jointes',
    DATE: 'Date',
    DETAIL: 'Détail',
    MESSAGE: 'Message',
    NO_ROWS_COMMUNICATIONS: 'Aucune communication',
    SENT_BY_F: 'Envoyée par',
    TITLE: 'Titre',
    UNREAD: 'Non lu'
  },
  SENTENCE: {},
  SUCCESS: {},
  TOOLTIP: {}
};
